"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgUsersShare(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 13.25a2.75 2.75 0 011.232 5.21A3.747 3.747 0 0115.75 22a.75.75 0 01-.75.75H9a.75.75 0 01-.75-.75 3.752 3.752 0 012.518-3.543A2.75 2.75 0 0112 13.25zm0 6.5c-.932 0-1.732.567-2.073 1.374l-.048.125h4.241l-.047-.125a2.252 2.252 0 00-1.919-1.369zm8.291-6.441c.382.16.561.6.4.982-.787 1.87-1.952 3.499-3.29 4.343a.75.75 0 01-.801-1.268c1.034-.653 2.03-2.044 2.709-3.657a.75.75 0 01.982-.4zm-15.6.4c.68 1.613 1.675 3.004 2.71 3.657a.75.75 0 01-.801 1.268c-1.339-.844-2.504-2.473-3.291-4.343a.75.75 0 111.382-.582zM12 14.749a1.25 1.25 0 100 2.501 1.25 1.25 0 000-2.5zm8-12.5a2.75 2.75 0 011.232 5.21A3.747 3.747 0 0123.75 11a.75.75 0 01-.75.75h-6a.75.75 0 01-.75-.75 3.752 3.752 0 012.518-3.542A2.75 2.75 0 0120 2.25zm-16 0a2.75 2.75 0 011.232 5.21A3.747 3.747 0 017.75 11a.75.75 0 01-.75.75H1A.75.75 0 01.25 11a3.752 3.752 0 012.518-3.542A2.75 2.75 0 014 2.25zm16 6.5c-.932 0-1.732.568-2.073 1.375l-.048.125h4.241l-.047-.125a2.252 2.252 0 00-1.919-1.369zm-16 0c-.932 0-1.732.568-2.073 1.375l-.048.125H6.12l-.047-.125a2.252 2.252 0 00-1.919-1.369zm16-5a1.25 1.25 0 100 2.501 1.25 1.25 0 000-2.5zm-16 0A1.25 1.25 0 104 6.25a1.25 1.25 0 000-2.5zm11.47-1.334a.75.75 0 11-.94 1.17c-1.383-1.113-3.678-1.113-5.06 0a.75.75 0 01-.94-1.17c1.93-1.554 5.008-1.553 6.94 0z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgUsersShare;
exports.default = _default;